import Button from "pages/_components/Button";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, connect } from "react-redux";
import { actions as comexActions, selectors as comexSelectors } from "reducers/comex";
import { Col, Row } from "react-bootstrap";
import { push } from "connected-react-router";
import CustomText from "pages/_components/CustomText/CustomText";
import ResponsiveHeader from "pages/_components/header";
import { COMEX_STATE } from "pages/comex/constants";
import TransactionsHistory from "./_components/TransactionsHistory";

const ComexPage = ({ isDesktop, fetching }) => {
    const dispatch = useDispatch();

    const tabsData = [
        {
            text: "comex.sent.requests",
            textType: "I18N",
        },
        {
            text: "comex.drafts",
            textType: "I18N",
        },
        {
            text: "comex.finished",
            textType: "I18N",
        },
    ];

    const initialTab = 0;

    useEffect(() => {
        dispatch(comexActions.setNewComexTransfer());
        dispatch(comexActions.setComexDataForContinue({}, "", null, null));
    }, []);

    return (
        <>
            <Notification scopeToShow="ComexPage" />
            <ResponsiveHeader id="request.transfers.comex.title" backLinkTo="/desktop" />
            <MainContainer showLoader={fetching}>
                <h3 style={{ paddingLeft: "30px" }}>
                    <CustomText text="request.transfers.comex.subtitle" textType="I18N" />
                </h3>

                <Row className="form-actions no-print">
                    <Col xs={12} md={4} mdOffset={1}>
                        <Button
                            className="btn btn-primary"
                            image="images/figma/icon/nuevo.svg"
                            onClick={() => dispatch(push("/comex/contact/add"))}
                            label="comex.new.contact"
                        />
                    </Col>
                    <Col xs={12} md={4}>
                        <Button
                            className="btn-outline"
                            image="images/figma/icon/contacts.svg"
                            label="comex.contacts"
                            onClick={() => dispatch(push("/comex/contact"))}
                        />
                    </Col>
                </Row>

                <CustomTabs tabsData={tabsData} tab={initialTab}>
                    <TransactionsHistory isDesktop={isDesktop} type={COMEX_STATE.SENT} />
                    <TransactionsHistory isDesktop={isDesktop} type={COMEX_STATE.DRAFT} />
                    <TransactionsHistory isDesktop={isDesktop} type={COMEX_STATE.FINISHED} />
                </CustomTabs>
            </MainContainer>
        </>
    );
};

ComexPage.propTypes = {
    isDesktop: bool.isRequired,
};

const mapStateToProps = (state) => ({
    fetching: comexSelectors.getFetching(state),
});

export default connect(mapStateToProps)(ComexPage);
